import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Box, CircularProgress, Divider, Typography } from '@mui/material'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { rowSelected, snackbarData, userCredentials } from 'recoilState/GlobalState'
import FileUpload from 'components/FileUpload'
import { SBMDocumentoPreviewGet } from 'services/services-mia/sbm/SBMDocumentoPreviewGet'
import PdfViewerComponent from '../ViewDoc/PdfViewerComponent'

const base64ToBlobUrl = (base64) => {
    const byteCharacters = atob(base64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: 'application/pdf' })
    return URL.createObjectURL(blob)
}

export default function UploadFile({ updateList }) {
    const xgridRowSelected = useRecoilValue(rowSelected)
    const credentials = useRecoilValue(userCredentials)
    const setSnackbarInfo = useSetRecoilState(snackbarData)
    const [pdfUrl, setPdfUrl] = useState(null)
    const [loadingPdf, setLoadingPdf] = useState(false)
    const blobUrlRef = useRef(null)

    const isSubido = xgridRowSelected?.row?.documentoEstado === 'S'

    const loadExistingPdf = useCallback(async () => {
        if (!isSubido || !xgridRowSelected?.row?.id || !credentials) return
        setLoadingPdf(true)
        try {
            const response = await SBMDocumentoPreviewGet(xgridRowSelected.row.id, credentials)
            const pdfBase64 = response.result?.[0]?.sbmDocumentoPDF
            if (pdfBase64) {
                if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current)
                const url = base64ToBlobUrl(pdfBase64)
                blobUrlRef.current = url
                setPdfUrl(url)
            }
        } catch {
            setSnackbarInfo({
                message: 'No se pudo cargar el documento existente',
                severity: 'error',
                open: true
            })
        } finally {
            setLoadingPdf(false)
        }
    }, [isSubido, xgridRowSelected?.row?.id, credentials, setSnackbarInfo])

    useEffect(() => {
        loadExistingPdf()
        return () => {
            if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current)
        }
    }, [loadExistingPdf])

    if (isSubido) {
        return (
            <Box sx={{ display: 'flex', gap: '1rem', width: '100%' }}>
                <Box sx={{ flex: '0 0 calc(50% - 0.5rem)', maxWidth: 'calc(50% - 1rem)', overflow: 'hidden' }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#06132f', textAlign: 'left' }}>
                        Documento actual
                    </Typography>
                    <Box sx={{ height: '50vh', borderRadius: 1 }}>
                        {loadingPdf ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                <CircularProgress />
                            </Box>
                        ) : pdfUrl ? (
                            <PdfViewerComponent pdfContent={pdfUrl} />
                        ) : null}
                    </Box>
                </Box>
                <Divider orientation="vertical" flexItem />
                <Box sx={{ flex: '0 0 calc(50% - 0.5rem)', maxWidth: 'calc(50% - 1rem)', overflow: 'hidden' }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#06132f', textAlign: 'left' }}>
                        Subir nuevo documento
                    </Typography>
                    <FileUpload updateList={updateList} />
                </Box>
            </Box>
        )
    }

    return (
        <div>
            <FileUpload updateList={updateList} />
        </div>
    )
}
